<template>
    <el-dialog title="Fields to display"
               :visible.sync="showForm"
               :close-on-click-modal="false">

        <table class="table">
            <thead>
                <tr>
                    <th style="width: 30px;"></th>
                    <th>Column</th>
                    <th>Description</th>
                    <th style="width: 30px;"></th>
                </tr>
            </thead>
            <draggable
                tag="tbody"
                handle=".handle"
                :list="my_columns"
            >
                <tr v-for="c in my_columns" v-if="c">
                    <td><i class="handle fas fa-bars"></i></td>
                    <td>{{ c.name }}</td>
                    <td>{{ c.description }}</td>
                    <td><i class="fas fa-times" @click="remove(c)" style="cursor: pointer"></i></td>
                </tr>
            </draggable>
        </table>

        <div style="display: flex">
            <el-select v-model="new_column" filterable placeholder="Add Column to List View" style="width: 100%">
                <el-option-group :label="section" v-for="(cols, section) in sections" :key="section">
                    <el-option
                        v-for="(option) in cols"
                        :key="option.id"
                        :label="option.name"
                        :value="option.id">
                    </el-option>
                </el-option-group>
            </el-select>
            <btn icon="fas fa-plus" cssClass="btn btn-sm btn-secondary" style="margin-left: 10px" :click="addColumn">Add Column</btn>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showForm = false">Close</el-button>
            <el-button type="primary" @click="save()">Save</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        props: [
            'show',
            'columns',
            'available_columns'
        ],
        data() {
            return {
                my_columns: this.mapColumns(this.columns),
                new_column: null
            };
        },
        watch: {
            columns() {
                this.my_columns = this.mapColumns(this.columns);
            }
        },
        computed: {
            showForm: {
                get() { return this.show; },
                set(val) { this.$emit('close'); }
            },
            column_names() {
                return _.map(this.my_columns.filter(f => f), (f) => f.id);
            },
            sections() {
                return _.groupBy(this.available_columns, (c) => c.section);
            }
        },
        methods: {
            mapColumns(names) {
                if (!this.available_columns || !names) return [];
                return _.map(names, (col_id) => this.available_columns[col_id])
                    .filter(col => col !== undefined);
            },

            remove(c) {
                this.my_columns = _.filter(this.my_columns, (f) => f.id !== c.id);
            },
            save() {
                this.$emit('updated', this.column_names);
                this.showForm = false;
            },
            addColumn() {
                if (!this.new_column || this.column_names.includes(this.new_column))
                    return;

                let col = _.find(this.available_columns, (c) => c.id === this.new_column);
                if (col) {
                    this.my_columns.push(col);
                }
            }
        }
    }
</script>

<style scoped>
</style>